import { easeQuadOut } from 'd3-ease';
import { interpolate } from 'd3-interpolate';
import { select } from 'd3-selection';
import 'd3-transition';
import * as React from 'react';
import styled from 'styled-components';
import SmilesIcon from './icons/SmilesIcon';
import Colors from 'src/lib/Colors';

interface IProps {
  amount: number;
  label?: string;
  className?: string;
  isAnimated?: boolean;
  onClick?: (() => void);
}

class UnstyledCreditDisplay extends React.Component<IProps> {
  public state = {
    arcs: [],
  };

  private element = React.createRef<HTMLElement>();

  public componentDidUpdate(newProps: IProps) {
    if (newProps.amount !== this.props.amount && this.props.isAnimated) {
      this.startAnimation(this.props.amount || 0, newProps.amount || 0);
    }
  }

  public componentDidMount() {
    if (this.props.isAnimated) {
      this.startAnimation(0, this.props.amount || 0);
    }
  }

  public render() {
    const classNames = [
      this.props.className,
    ].filter(Boolean);

    return <section className={ classNames.join(' ') } ref={this.element}
                    onClick={this.props.onClick}>
      <span className="amount">
        {this.props.label}
        {this.props.isAnimated ? '0' : this.props.amount}
      </span>
      &nbsp;
      <SmilesIcon fillColor={Colors.almostWhite}/>
    </section>;
  }

  private startAnimation(previousAmount: number, newAmount: number) {
    // console.log('Animating to amount', newAmount);

    select(this.element.current)
      .select('.amount')
      .transition()
      .ease(easeQuadOut)
      .duration(200 + Math.min(Math.abs(newAmount - previousAmount) * 10, 1000))
      .tween('text', function tween() {
        const i = interpolate(previousAmount, newAmount);
        return t => select(this).text(Math.floor(i(t)));
      });
      // .on('end', () => {});
  }
}

const CreditDisplay = styled(UnstyledCreditDisplay)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  align-self: center;

  min-width: 5rem;
  margin: 0.25rem 0.5rem;
  padding: 0;
  background-color: ${Colors.mutedText};
  border-radius: 1.8rem;

  font-size: 1rem;
  line-height: 1rem;
  height: 1.5rem;
  font-weight: 500;
  white-space: nowrap;

  color: white;
  text-align: center;

  opacity: 0.6;
  transition: opacity 0.3s ease-out;
`;

export default CreditDisplay;



// WEBPACK FOOTER //
// ./src/components/CreditDisplay.tsx